'use client'

import { CloseButton, Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

import { LoginModalForm } from '@src/components/LoginModal/LoginModalForm'
import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop'
import { cn } from '@src/utils/tailwind'

interface LoginModalProps {
  heading?: string
  subHeading?: string
  disclaimer?: string
  isOpen: boolean
  onClose: () => void
  redirectUrl?: string
}

export const LoginModal = (props: LoginModalProps) => {
  const { heading, subHeading, disclaimer, isOpen, onClose, redirectUrl } = props

  return (
    <Dialog transition open={isOpen} onClose={onClose} as="div" className="relative z-1000">
      <ModalBackdrop className="backdrop-blur-sm" />

      <div className="fixed inset-0 flex items-center overflow-y-auto lg:p-2">
        <DialogPanel
          transition
          className={cn(
            'relative mx-auto h-full overflow-hidden bg-white shadow-md transition-all lg:h-auto lg:rounded-3xl',
            'w-full p-6 pb-14 lg:max-w-[520px] lg:p-16',
            'data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-150 data-enter:ease-out data-leave:duration-150 data-leave:ease-in data-closed:lg:translate-y-0 data-closed:lg:scale-95'
          )}
        >
          <CloseButton
            className={cn(
              'absolute top-4 right-4 flex items-center justify-center rounded-full p-1 text-bodi-black-text transition-all hover:bg-gray-100'
            )}
          >
            <XMarkIcon className="size-6 stroke-[2px]" />
          </CloseButton>
          <div className="mx-auto mt-12 flex flex-col items-center justify-center gap-4 text-left lg:mt-0 lg:max-w-[390px]">
            <DialogTitle className="text-heading-display-3 w-full lg:text-center">
              {heading}
            </DialogTitle>
            <div className="mb-12 w-full text-body-base lg:mb-0 lg:text-center">{subHeading}</div>
            <LoginModalForm onClose={onClose} isOpen={isOpen} redirectUrl={redirectUrl} />
            <div
              className="text-center text-body-base [&_a]:underline"
              dangerouslySetInnerHTML={{ __html: disclaimer ?? '' }}
            />
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}
